{
  "headings": {
    "preview": "Vikailmoituksen esikatselu",
    "defectNotice": "Tee vikailmoitus",
    "defectNoticeEdit": "Muokkaa vikailmoitusta",
    "success": "Vikailmoitus",
    "editNotice": "Vikailmoitus"
  },
  "texts": {
    "instructions": "Ilmoita kiireettömästä viasta asunnossasi tai yleisissä tiloissa. Kiireellisissä tapauksissa, kuten vesivahingoissa, soita huoltoyhtiöön.",
    "list": {
      "title": "Tekemäsi vikailmoitus",
      "workOrder": "Vikailmoitukseen liitetty tilaus",
      "status": {
        "completed": "Merkitty käsitellyksi",
        "created": "Luotu"
      }
    },
    "eventsTitle": "Seuraa edistymistä",
    "notEditable": "Tätä ilmoitusta ei voi enää muokata.",
    "notTrackable": "Ilmoitus on siirretty toiseen kohteeseen. Sitä ei voi enää muokata eikä sen etenemistä seurata."
  },
  "placeholders": {
    "title": "Otsikko",
    "description": "Kuvaile ongelmaa tarkemmin",
    "defectClass": "Valitse joku muun tyyppinen vika"
  },
  "alt": {
    "successIllustration": "Kiitos kuvitus"
  },
  "labels": {
    "defectLocation": "Vian kohde",
    "defectClass": "Vian tyyppi",
    "title": "Otsikko",
    "description": "Kuvaus",
    "files": "Liitteet",
    "masterKeyAccessAllowed": "Asuntoon saa tulla yleisavaimella",
    "hasPetsInApartment": "Lemmikkejä huoneistossa"
  },
  "actions": {
    "back": "Takaisin",
    "resetForm": "Tyhjennä lomake",
    "sendForm": "Lähetä vikailmoitus"
  },
  "defectLocations": {
    "contractTarget": "Asunto {{target}}",
    "commonArea": "Yhteiset tilat"
  },
  "errors": {
    "missingUserPhoneNumber": {
      "title": "Vikailmoituksen luonti ei valitettavasti onnistu",
      "message": "Jatkaaksesi vikailmoituksen tekemistä, lisää puhelinnumerosi profiiliisi."
    },
    "submitError": "Virhe vikailmoituksen lähetyksessä. Jos ongelma jatkuu, tai jos vika on kiireellinen ota yhteyttä asiakaspalveluun.",
    "serviceUnavailable": "Vikailmoituksen luonti ei juuri nyt onnistu. Ole hyvä ja yritä myöhemmin uudelleen."
  },
  "events": {
    "created": "Luotu",
    "completed": "Merkitty käsitellyksi",
    "workOrderLinked": "Tilaus #{{id}} liitetty",
    "workNoteCreated": "Työkirjaus: {{note}}",
    "workOrderCreated": "Työtilaus #{{id}} luotu",
    "workOrderStarted": "Työtilaus #{{id}} aloitettu",
    "workOrderCompleted": "Työtilaus #{{id}} merkitty valmiiksi",
    "workOrderAccepted": "Työtilaus #{{id}} hyväksytty"
  },
  "defectClasses": {
    "-1": "Muun tyyppinen vika",
    "1": "Korjaus",
    "2": "LVI",
    "3": "Pienkorjaus",
    "4": "Sähkö",
    "5": "Siivous",
    "6": "Hankinta",
    "7": "Ilkivalta",
    "8": "Kosteus",
    "9": "Lisäjäte",
    "10": "Lisäsiivous",
    "11": "Lukitus",
    "12": "Olosuhteet",
    "13": "Palovahinko",
    "14": "Rakennusautomaatio",
    "15": "Rakenteet",
    "16": "Talvihoitovahinko",
    "17": "Tietoliikenneyhteydet",
    "18": "Tuholaiset",
    "19": "Vesivahinko"
  }
}
